exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".in {\n  display: block;\n}\n.navigation {\n  display: flex;\n}\n.navigation > div {\n  flex: 1;\n  margin: 0 0 10px;\n}\n.navigation button {\n  margin: 0 2px;\n  width: 30px;\n  text-align: center;\n}\n.navigation--prev {\n  display: flex;\n  justify-content: flex-start;\n}\n.navigation--next {\n  display: flex;\n  justify-content: flex-end;\n}\n.portion-amount__input {\n  margin-left: 25%;\n}\n.number__select input {\n  max-width: 65px;\n}\n.form-control-xs[type=number] {\n  width: 65px;\n}", ""]);

// exports
